export default function convertTimesArrayToString(renderingTimes: any[]) {
    let returnString = '[';
    Object.keys(renderingTimes).forEach((element, index) => {
        if (index !== 0) {
            returnString += ', ';
        }
        returnString += `"${element}": "${renderingTimes[element]}"`;
    });
    returnString += ']';

    return returnString;
}
